import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useReferralAnalyses from 'hooks/useReferralAnalyses';
import { referralAnalysesSelectors } from "features/referralAnalyses";

const ReferralAnalysesList = () => {
  const { getReferralAnalyses } = useReferralAnalyses();
  const { data, pagination } = useCustomSelector(referralAnalysesSelectors.getReferralAnalysesData);
  const fetching = useCustomSelector(referralAnalysesSelectors.referralAnalysesIsFetching);

  return (
     <BaseAnalysesList
      fetchData={getReferralAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ReferralAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);